<template>
  <div class="w-full h-full">
    <div
      class="w-full h-full model-view"
      ref="modelEngine"
      v-loading="loadingEngine && !collisionReload"
      element-loading-background="#0a232c"
      :class="[
        modelWidth === 1 / 2 ? 'w-1/2' : '!w-100vw',
        { 'no-loading-icon': showLoadProgress },
        currentTenantId && currentTenantId === 'ae74a83f-34bc-4c20-9c27-73b8e233532b'
          ? 'error-image-bg'
          : 'error-color-bg',
      ]"
    >
      <img
        id="playerEngineId"
        class="engineImg w-full"
        v-if="modelSetting.cloudRenderLoadMode === 'img'"
      />
      <video
        id="playerEngineId"
        autoplay
        playsinline
        muted
        class="engineVideo w-full"
        :style="{ objectFit: modelSetting.engineNodeServer ? 'contain' : 'fill' }"
        v-if="modelSetting.cloudRenderLoadMode !== 'img' && !showScreenShot"
      ></video>
      <!-- 断开会话显示最后一帧截图 -->
      <img
        class="engineImg w-full"
        v-if="modelSetting.cloudRenderLoadMode !== 'img' && showScreenShot"
        :src="screenShotSrc"
      />
      <!-- 模型进度条 -->
    </div>
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
  </div>
</template>

<script>
import { ModelSceneApi, AnimationApi } from '@wiz-api/scene-management'
import { get } from 'lodash'
import cloudRender from '../../assets/js/model/index'
import EngineNodeService from '../../service/EngineNodeService'
import { getPreferenceSettings } from '../../assets/js/model/modelSetting'
import {
  loadAction,
  loadSceneFromJson,
  isJSONObj,
  getNodesByNodeType,
  generateGUID,
} from '../../assets/js/scene/scene'
import downloadFile from '../../assets/js/model/modelDownload'
import CloudProxyService from '../../../cloud-render-management/services/CloudProxyService'

const modelSceneApi = new ModelSceneApi()
const animationApi = new AnimationApi()

const PlayerProgress = () => {
  return import('./PlayerProgress')
}
export default {
  name: 'ModelView',
  components: { PlayerProgress },
  props: {
    loadModelType: {
      type: String,
      defalut: 'modelFileId',
    },
    sourceId: {
      type: String,
      defalut: '',
    },
    collisionReload: {
      type: Boolean,
      defalut: false,
    },
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
        }
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
    modelWidth: {
      type: Number,
      defalut: 1, // 模型的宽度
    },
    moveVisualAngleFlag: {
      type: Boolean,
      default: false,
    },
    modelEngineTransform: {
      type: String,
      default: 'scale(1, 1)',
    },
  },
  data() {
    return {
      screenShotSrc: '',
      showScreenShot: false,
      player: null, // player实例
      loadingEngine: false, // 引擎加载状态
      showLoadProgress: false, // 进度条显隐
      loadType: '', // 进度条类型
      loadPercentage: 0, // 进度条值
      sceneOptions: {
        isEnableGis: '',
        longitude: '',
        latitude: '',
        name: '',
        id: '',
        jsonData: '',
      },
      sceneRootNode: 0,
      sceneFileList: [],
      sceneFileCount: 0,
      sceneData: {},
      loadedModels: [],
      modelEngineId: '',
      engineList: [],
      customeEngineId: '',
      loadNodeList: [],
      currentLoadNodes: [],
      animationNodes: [],
      animationActions: [],
      currentAnimationSceneId: '',
      lastSelectNode: null,
    }
  },
  computed: {
    // 是否使用js版本的云渲染接口
    currentCloudRender() {
      return this.visualizationConfig.useOriginSdk ? cloudRender : this.cloudRender
    },
    // 可视化相关设置
    visualizationConfig() {
      return Wiz.globalSettings.globalConfig?.visualizationConfig || {}
    },
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
    // 云渲染协议
    cloudProtocol() {
      return this.modelSetting.cloudProtocol || 'ws'
    },
    // 云渲染服务路径
    cloudServerPath() {
      return this.modelSetting.cloudServerPathVulkan || 'renderapi.wiz.top:7082'
    },
    // 模型文件
    modelFileList() {
      return this.modelSetting.modelFileList || []
    },
    currentTenantId() {
      return (
        JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId ||
        localStorage.getItem('CurrentTenantId') ||
        ''
      )
    },
  },
  watch: {
    player: {
      async handler(val, oldVal) {
        if (val._ws.readyState === 0) {
          let videoWidth = null
          let videoHeight = null
          videoWidth = document.getElementById('playerEngineId').offsetWidth // 获取 video的宽度
          videoHeight = document.getElementById('playerEngineId').offsetHeight // 获取 video的高度
          await this.player.resize(1024, 1024) // 如果直接设置当前分辨率引擎不会响应，所以需要先设置一个其他分辨率
          setTimeout(async () => {
            await this.player.resize(videoWidth, videoHeight) // 设置为当前窗口的尺寸，让画面尺寸恢复正常
          }, 100)
        }
      },
      deep: true,
    },
    async sourceId(val, oldVal) {
      this.loadNodeList = []
      if (!val || val === 'empty') {
        if (this.player) {
          await this.destroyNode()
        } else {
          // 如果是第一次进来
          this.loadPercentage = 100
          setTimeout(() => {
            this.showLoadProgress = false
            this.loadingEngine = false
          }, 500)
        }
        this.$emit('loadModelEnd')
        return
      }
      if (val && val !== oldVal && this.loadModelType === 'sceneId') {
        if (oldVal === 'empty') {
          this.showLoadProgress = true
          this.loadingEngine = true
          this.loadPercentage = 0
          this.getSceneInfo(val)
          return
        }
        if (this.modelSetting.engineNodeServer) {
          await this.forceTerminate(this.modelEngineId || this.customeEngineId)
          this.modelEngineId = await this.getFreeEngineId()
          this.runPlayer()
          return
        }
        if (!this.modelSetting.engineLoadAnimation) {
          // 需要加载enginLoad动画的情况，不打开进度条-天生港定制
          this.showLoadProgress = true
          this.loadingEngine = true
          this.loadPercentage = 0
        }
        if (this.player) {
          await this.destroyNode()
          this.getSceneInfo(val)
        } else {
          this.runPlayer()
        }
      }
      if (val === oldVal) {
        this.$emit('loadModelEnd')
      }
    },
    async sceneFileCount(num) {
      if (num === 0) {
        return
      }
      if (num >= this.sceneFileList.length) {
        if (this.visualizationConfig.loadInterface !== 'Node') {
          this.player.Native.Node.EventLoadFileProgress.connect(this.checkModelLoad)
        }
        if (this.visualizationConfig.loadInterface === 'Node' && !this.showLoadProgress) {
          this.loadType = '加载中...'
          this.showLoadProgress = true
        }
        console.log('sceneFileCount', this.sceneData)
        this.loadNodeList = await loadSceneFromJson(
          this.sceneData,
          this.sceneRootNode,
          this.player,
          this.sceneOptions,
          [],
          this.loadNodeCallback,
          this.collisionReload
        )
        this.sceneFileCount = 0
        await this.moveVisualAngle()
        if (this.visualizationConfig.loadInterface !== 'Node') {
          this.player.Native.Node.EventLoadFileProgress.disconnect(this.checkModelLoad)
          this.loadedModels = []
        }
        console.log('模型加载结束1')
        this.$emit('loadModelEnd')
        this.showLoadProgress = false
        this.loadPercentage = 0
        this.loadingEngine = false
        this.getAnimationNodes()
      } else {
        this.checkTextureFile(this.sceneFileList[num])
      }
    },
    moveVisualAngleFlag() {
      this.moveVisualAngle()
    },
    modelEngineTransform() {
      this.handleScale()
    },
  },
  async mounted() {
    this.handleScale()
    if (!this.modelSetting.engineNodeServer && !this.modelSetting.engineLoadAnimation) {
      this.showLoadProgress = true
      this.loadingEngine = true
    } else if (!this.modelSetting.engineNodeServer && this.modelSetting.engineLoadAnimation) {
      // 模型加载前进度条改为loading动画-天生港定制
      this.$emit('loadingSwitch', { bol: true, title: '引擎连接中...' })
    }
    window.addEventListener('beforeunload', async (e) => {
      if (this.modelSetting.engineNodeServer) {
        this.player.config.maxTimeout = 0
        const param = {
          signalServer: `${this.cloudProtocol}://${this.cloudServerPath}`,
          options: {
            engineId: this.modelEngineId || this.customeEngineId,
            maxTimeout: 0, // 会话超时时间，允许掉线后引擎保存多久，在该时间内可重新连接到会话，否则会创建新的会话
            openDebug: this.modelSetting.openDebug || false,
          },
        }
        const { data } = await this.currentCloudRender.Engine.loadEngine(param)
        if (this.visualizationConfig.useOriginSdk) {
          data.exit()
        } else {
          data.getDataInfo().exit()
        }
        // await this.forceTerminate(this.modelEngineId || this.customeEngineId)
      } else if (this.player) {
        this.player.exit()
      }
    })
    this.isEnableGisEarthAnimation()
  },
  beforeDestroy() {
    this.player.Native.Node.EventPickUpNode.disconnect(this.watchMsg)
    this.player.Native.Node.EventSelectNode.disconnect(this.selectWatch)
    if (this.modelSetting.engineNodeServer) {
      this.forceTerminate(this.modelEngineId || this.customeEngineId)
    } else if (this.player) {
      this.player.exit()
    }
  },
  methods: {
    // 监听节点动画
    async watchActionUpdate(data) {
      if (data && data.sender && data.state === 2) {
        const findAction = _.find(this.animationActions, ['action', data.sender])
        if (findAction && findAction.animationDetail.loopType === 0) {
          this.stopSingleLoop(findAction)
        }
      }
    },
    // 停止动画
    async stopSingleLoop(data) {
      await this.player.Native.AnimationAction.unbindActionUpdate(data.action)
      await this.player.Native.AnimationAction.stop(data.action)
      if (data.nodeAnimationDetails.length && data.currentNode) {
        if (this.currentAnimationSceneId !== this.sourceId) {
          return
        }
        await this.player.Native.Node.setProperty(data.currentNode, {
          localTrans: data.originStatus.localPosition,
        })
        if (this.currentAnimationSceneId !== this.sourceId) {
          return
        }
        await this.player.Native.Node.setProperty(data.currentNode, {
          localRot: data.originStatus.localRotation,
        })
        if (this.currentAnimationSceneId !== this.sourceId) {
          return
        }
        await this.player.Native.Node.setProperty(data.currentNode, {
          localScale: data.originStatus.localScaling,
        })
      }
    },
    // 获取动画节点
    async getAnimationNodes() {
      const [err, res] = await animationApi.getList({
        sceneId: this.sourceId,
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && res.items.length) {
        this.currentAnimationSceneId = this.sourceId
        this.player.Native.Setting.set('sys.autoUpdateFrame', false)
        this.animationNodes = res.items
        await this.player.Native.Node.setAxisEditType(0)
        this.player.Native.AnimationAction.EventActionUpdate.connect(this.watchActionUpdate)
        _.forEach(this.animationNodes, (item) => {
          this.getAnimationDetails(item.id, item.nodeCode, item.nodeName)
        })
      }
    },
    // 获取动画详情
    async getAnimationDetails(id, nodeCode, nodeName) {
      const [err, res] = await animationApi.get(id)
      if (!err) {
        const nodeAnimationDetails = _.sortBy(res.details, 'seqNo')
        const animationDetail = {
          loopInterval: res.loopInterval,
          speed: res.speed,
          loopType: res.loopType === -1 ? 0 : res.loopType,
          speedCurve: res.speedCurve === -1 ? 0 : res.speedCurve,
        }
        if (this.currentAnimationSceneId !== this.sourceId) {
          return
        }
        const currentRoot = await this.player.Native.Node.getRoot()
        if (this.currentAnimationSceneId !== this.sourceId) {
          return
        }
        const rootNode = await this.player.Native.Node.findNodeByCode(currentRoot, nodeCode)
        if (rootNode) {
          if (this.currentAnimationSceneId !== this.sourceId) {
            return
          }
          const findNodes = await this.player.Native.Node.findNodeByName(rootNode, nodeName)
          if (!_.isEmpty(findNodes)) {
            const currentNode = findNodes
            if (this.currentAnimationSceneId !== this.sourceId) {
              return
            }
            const originStatus = await this.getNodeStatus(currentNode)
            if (this.currentAnimationSceneId !== this.sourceId) {
              return
            }
            const currentAction = await loadAction(
              nodeAnimationDetails,
              currentNode,
              animationDetail,
              this.player,
              this.currentAnimationSceneId === this.sourceId
            )
            this.animationActions.push({
              id,
              nodeAnimationDetails,
              currentNode,
              originStatus,
              animationDetail,
              action: currentAction,
            })
          }
        }
      }
    },
    // 获取状态信息
    async getNodeStatus(node) {
      const dataInfo = {
        localPosition: null,
        localRotation: null,
        localScaling: null,
      }
      if (this.currentAnimationSceneId !== this.sourceId) {
        return {}
      }
      const data = await this.player.Native.Node.getProperty(node, [
        'localTrans',
        'localRot',
        'localScale',
      ])
      dataInfo.localPosition = data.localTrans
      if (this.currentAnimationSceneId !== this.sourceId) {
        return {}
      }
      dataInfo.localRotation = data.localRot
      if (this.currentAnimationSceneId !== this.sourceId) {
        return {}
      }
      dataInfo.localScaling = data.localScale
      return dataInfo
    },
    async destroyNode() {
      this.currentCloudRender.GIS.unLoadGis()
      await this.player.Native.AnimationAction.EventActionUpdate.disconnect(this.watchActionUpdate)
      const mixer = await this.player.Native.AnimationMixer.getMixer('review')
      await this.player.Native.AnimationAction.stopActions(mixer)
      this.animationActions = []
      this.sceneOptions = this.$options.data().sceneOptions
      this.sceneRootNode = 0
      this.sceneFileList = []
      this.sceneFileCount = 0
      this.sceneData = {}
      const currentRoot = await this.player.Native.Node.getRoot()
      if (currentRoot) {
        await this.player.Native.Node.destroy(currentRoot)
      }
    },
    loadNodeCallback(data) {
      if (this.visualizationConfig.loadInterface === 'Node') {
        const scenceModelList = _.filter(this.sceneFileList, (item) => {
          return (
            item.code && (item.code?.type === 'modelFile' || item.code?.type === 'dynamicEffects')
          )
        })
        const loadNodes = _.filter(data, (item) => {
          return item.type === 'modelFile' || item.type === 'dynamicEffects'
        })
        console.log('loadNodes', loadNodes)
        if (loadNodes.length <= scenceModelList.length) {
          this.loadPercentage = _.round((loadNodes.length / scenceModelList.length) * 100, 2)
        }
      }
    },
    // 初始移动视角
    async moveVisualAngle() {
      if (this.sceneOptions.isEnableGis) {
        await this.moveToLLH(this.sceneOptions.longitude, this.sceneOptions.latitude)
      }
      if (this.sceneData.cameraParams && isJSONObj(this.sceneData.cameraParams)) {
        const { eye, target, up } = JSON.parse(this.sceneData.cameraParams)
        await this.player.Native.Camera.addMoveTo(eye, target, up, 2)
      } else {
        const currentNodes = _.map(_.filter(this.loadNodeList, ['type', 'modelFile']), 'nodePtr')
        await this.moveToScene(currentNodes, 1)
      }
    },
    // 强制终止连接
    async forceTerminate(id) {
      if (id) {
        const [err, res] = await CloudProxyService.forceTerminate({
          id,
        })
      }
    },
    // 获取引擎id
    async getFreeEngineId() {
      const sassName = Wiz.AuthHooks?.GetUserInfo().profile?.name
      const diyName = get(JSON.parse(localStorage.getItem('CurrentUser')), 'Account')
      const [err, res] = await EngineNodeService.getFreeEngineId({
        trueName: sassName || diyName || '',
        sceneId: this.sourceId,
      })
      if (!err && res && res.code === 200 && res.data && res.data.engineId) {
        return res.data.engineId
      }
      return ''
    },
    // 监听模型加载进度
    checkModelLoad(taskId, data, node, name) {
      const modelList = _.filter(this.sceneFileList, (item) => {
        return (
          item.code &&
          item.code?.type === 'modelFile' &&
          _.last(item.code?.filePath.split('.')) === 'pr'
        )
      })
      if (!this.showLoadProgress) {
        this.loadType = '加载中...'
        this.showLoadProgress = true
      }
      if (data >= 1) {
        this.loadedModels.push(name)
      }
      // this.loadPercentage = _.round((_.uniq(this.loadedModels).length / modelList.length) * 100, 2)
      this.loadPercentage = data * 100
    },
    // 获取场景aabb
    async getSceneAabb(nodes) {
      const aabbList = []
      for (let i = 0; i < nodes.length; i += 1) {
        const item = nodes[i]
        // eslint-disable-next-line no-await-in-loop
        const data = await this.player.Native.Node.getProperty(item, ['aabb'])
        if (data && data.aabb) {
          aabbList.push(data.aabb)
        }
      }
      const maxX = _.maxBy(aabbList, (item) => {
        return item[1][0]
      })
      const maxY = _.maxBy(aabbList, (item) => {
        return item[1][1]
      })
      const maxZ = _.maxBy(aabbList, (item) => {
        return item[1][2]
      })
      const minX = _.minBy(aabbList, (item) => {
        return item[0][0]
      })
      const minY = _.minBy(aabbList, (item) => {
        return item[0][1]
      })
      const minZ = _.minBy(aabbList, (item) => {
        return item[0][2]
      })
      return {
        max: [maxX[1][0], maxY[1][1], maxZ[1][2]],
        min: [minX[0][0], minY[0][1], minZ[0][2]],
      }
    },
    // 移动相机到模型
    async moveToScene(nodes, face) {
      if (nodes.length) {
        const modelAabb = await this.getSceneAabb(nodes)
        const mat = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]
        await this.player.Native.Camera.addMoveToAabb(modelAabb, mat, face, 1.5, 2)
      }
    },
    // 加载player引擎
    async runPlayer() {
      if (!this.modelEngineId) {
        this.customeEngineId = generateGUID()
      }
      if (this.modelSetting.engineNodeServer) {
        localStorage.setItem('modelEngineId', this.modelEngineId || this.customeEngineId)
      }
      const param = {
        signalServer: `${this.cloudProtocol}://${this.cloudServerPath}`,
        options: {
          engineId: this.modelEngineId || this.customeEngineId,
          DomType: this.modelSetting.cloudRenderLoadMode === 'img' ? 1 : 0,
          videoDom: document.getElementById('playerEngineId'), // 绑定视频标签
          imgDom: document.getElementById('playerEngineId'), // 绑定视频标签
          userTimeout: 1000 * 60 * 60, // 用户操作超时设置，毫秒
          exitTimeout: 1000 * 60 * 1, // 用户超时后多久断开会话
          maxTimeout: 30000, // 会话超时时间，允许掉线后引擎保存多久，在该时间内可重新连接到会话，否则会创建新的会话
          openDebug: this.modelSetting.openDebug || false,
        },
      }
      const { data } = await this.currentCloudRender.Engine.loadEngine(param)
      if (this.visualizationConfig.useOriginSdk) {
        this.player = data
      } else {
        this.player = data.getDataInfo()
        this.currentCloudRender.Dispatch.on('Engine', async (e) => {
          if (e.type === 'Connected') {
            console.log('连接成功')
            const videoWidth = document.getElementById('playerEngineId').offsetWidth // 获取 video的宽度
            const videoHeight = document.getElementById('playerEngineId').offsetHeight // 获取 video的高度
            await this.player.resize(1024, 1024) // 如果直接设置当前分辨率引擎不会响应，所以需要先设置一个其他分辨率
            setTimeout(async () => {
              await this.player.resize(videoWidth, videoHeight) // 设置为当前窗口的尺寸，让画面尺寸恢复正常
            }, 3000)
          }
          if (e.type === 'Disconnected') {
            console.log('引擎断开连接')
            this.player.reconnect()
          }
          if (e.type === 'UserTimeOut') {
            // 用户操作超时
            this.player.resetTimer()
            const screenShotRes = await this.currentCloudRender.Camera.screenShot()
            this.screenShotSrc = `data:image/jpg;base64,${screenShotRes.data}`
          }
          if (e.type === 'TimeOutExit' && this.screenShotSrc) {
            // 断开会话
            console.log('断开会话')
            this.showScreenShot = true
          }
          if (e.type === 'CloseSession') {
            console.log('引擎端主动断开连接')
            this.player.reconnect()
          }
        })
      }
      window.player = this.player
      // 实例化完成将实例化后的player传出去
      this.$emit('sendPlayer', this.player)
      if (!this.modelSetting.engineNodeServer && this.modelSetting.engineLoadAnimation) {
        // 模型加载前进度条改为loading动画-天生港定制
        this.$emit('loadingSwitch', { bol: true, title: '引擎初始化中...' })
      }
      this.initPlayer()
    },
    // loading结束
    setLoadingEnd() {
      setTimeout(() => {
        this.loadingEngine = false
        document.getElementById('playerEngineId').removeEventListener('resize', this.setLoadingEnd)
      }, 500)
    },
    // 初始化player
    async initPlayer() {
      if (this.modelSetting.engineNodeServer && this.modelSetting.cloudRenderLoadMode !== 'img') {
        if (!document.getElementById('playerEngineId')) {
          return
        }
        document.getElementById('playerEngineId').addEventListener('resize', this.setLoadingEnd)
      }
      if (!this.modelEngineId) {
        // 设置点选时其他节点半透明
        // this.player.Native.Setting.set('display.bgTransparent.alpha', '0.5')
        // this.player.Native.Setting.set('display.bgTransparent.enable', true)
        const settingsFileUrl = `data://../apps/${this.modelSetting.folderName}/settings.json`
        const settingsData = await this.player.Native.File.loadText(settingsFileUrl)
        if (settingsData) {
          const defaultSettings = JSON.parse(settingsData)
          _.forEach(defaultSettings.Show, (item) => {
            this.player.Native.Setting.set(item.name, item.value)
          })
        }
        if (this.loadModelType === 'modelFileId' && this.sourceId) {
          this.loadModels()
        } else if (this.loadModelType === 'sceneId') {
          this.getSceneInfo(this.sourceId)
          this.loadGisEarth(
            this.player,
            'data://map-prpk-local.gis.xml',
            'data://models/sampler.pr',
            [114.42, 23.11, 0]
          )
        }
      } else {
        console.log('模型加载结束2')
        this.$emit('loadModelEnd')
        const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({
          id: this.sourceId,
        })
        if (!jsonErr) {
          const jsonData = JSON.parse(jsonRes)
          if (jsonData.cameraParams && isJSONObj(jsonData.cameraParams)) {
            const { eye, target, up } = JSON.parse(jsonData.cameraParams)
            await this.player.Native.Camera.addMoveTo(eye, target, up, 2)
          }
        }
      }
      await getPreferenceSettings(true, this.player)
      // 点选监听
      this.player.Native.Node.EventPickUpNode.connect(this.watchMsg)
      this.player.Native.Node.EventSelectNode.connect(this.selectWatch)
    },
    // 获取场景信息
    async getSceneInfo(id) {
      if (id) {
        const [err, res] = await modelSceneApi.get(id)
        if (!err) {
          this.sceneOptions = _.pick(res, ['isEnableGis', 'longitude', 'latitude', 'name', 'id'])
        }
        const [jsonErr, jsonRes] = await modelSceneApi.getModelSecenRelatedJson({ id })
        if (!jsonErr) {
          this.sceneOptions.jsonData = jsonRes
        }
        // 获取到经纬度添加地图
        if (this.sceneOptions.isEnableGis) {
          this.player.Native.GisPlatform.setCameraTerrainCollisionEnabled(false)
          await this.currentCloudRender.GIS.loadGis(this.modelSetting.globalMapPath)
        }
        this.$emit('setSceneOptions', this.sceneOptions)
      }
      if (!this.modelSetting.engineNodeServer && this.modelSetting.engineLoadAnimation) {
        // 模型加载前进度条改为loading动画-天生港定制
        this.$emit('loadingSwitch', { bol: false, title: '引擎初始化完成' })
      }
      this.loadScene()
    },
    // 移动相机到经纬度
    async moveToLLH(long, lat) {
      if (long && lat) {
        const elevation = (await this.player.Native.GisPlatform.queryDEM([[long, lat, 0]]))[0]
        this.player.Native.Camera.addMoveToLLH([long, lat, 20000], 5)
      }
    },
    // 加载场景
    async loadScene() {
      this.sceneRootNode = await this.player.Native.Node.getRoot()
      if (this.sceneOptions.jsonData && isJSONObj(this.sceneOptions.jsonData)) {
        this.sceneData = JSON.parse(this.sceneOptions.jsonData)
        this.sceneFileList = await getNodesByNodeType(this.sceneData, [])
        if (!_.isEmpty(this.sceneFileList)) {
          this.checkTextureFile(this.sceneFileList[0])
          return
        }
        console.log('loadScene', this.sceneData)
        await loadSceneFromJson(
          this.sceneData,
          this.sceneRootNode,
          this.player,
          this.sceneOptions,
          [],
          this.loadNodeCallback,
          this.collisionReload
        )
        if (this.sceneOptions.isEnableGis) {
          await this.moveToLLH(this.sceneOptions.longitude, this.sceneOptions.latitude)
        }
        if (this.sceneData.cameraParams && isJSONObj(this.sceneData.cameraParams)) {
          const { eye, target, up } = JSON.parse(this.sceneData.cameraParams)
          await this.player.Native.Camera.addMoveTo(eye, target, up, 2)
        }
        this.$emit('loadModelEnd')
        console.log('模型加载结束3')
      } else {
        const nodePtr = await this.player.Native.NodeProxy.createNode(
          this.sceneRootNode,
          this.sceneOptions.name
        )
        if (
          this.sceneOptions.isEnableGis &&
          this.sceneOptions.longitude &&
          this.sceneOptions.latitude
        ) {
          const elevation = (
            await this.player.Native.GisPlatform.queryDEM([
              [this.sceneOptions.longitude, this.sceneOptions.latitude, 0],
            ])
          )[0]
          await this.player.Native.NodeProxy.setNodeGisPos(nodePtr, [
            this.sceneOptions.longitude,
            this.sceneOptions.latitude,
            elevation,
          ])
        }
        await this.player.Native.NodeProxy.setNodeInfo(nodePtr, {
          code: JSON.stringify({
            type: 'Root',
            fileType: '',
            filePath: '',
            scene: this.sceneOptions.id,
            isEnableGis: this.sceneOptions.isEnableGis,
          }),
        })
        console.log('模型加载结束4')
        this.$emit('loadModelEnd')
      }
      this.loadPercentage = 100
      setTimeout(() => {
        this.showLoadProgress = false
        this.loadingEngine = false
      }, 500)
    },
    // 检查文件是否存在
    async checkTextureFile(data) {
      console.log('checkTextureFile', data)
      if (data && data.code && data.code.modelFileId) {
        if (data.code.materialFileId && data.code.materialFileId !== 'undefined') {
          const url = `data://../apps/${data.code.filePath.split('/')[4]}/models/${
            data.code.modelFileId
          }/${data.code.modelFileId}.zip`
          const fileInfo = {
            id: data.code.materialFileId,
            url,
            fileType: 'zip',
          }
          const apiConfig = {
            path: `${
              Wiz.GetApiClientInstance('file-management')?.basePath
            }/api/file-management/files/${data.code.materialFileId}/download`,
            method: 'GET',
            headers: {
              Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
            },
          }
          const res = await downloadFile(
            this.player,
            fileInfo,
            apiConfig,
            this.progressMsg,
            this.downloadMaterialMsg(data)
          )
          console.log('res', res)
          if (res.type === 0 && res.success) {
            this.checkModelFile(data)
          } else {
            this.showLoadProgress = true
            this.loadType = '下载中...'
          }
        } else {
          this.checkModelFile(data)
        }
      }
    },
    // 检查模型是否存在
    async checkModelFile(data) {
      const fileType = _.last(data.code.filePath.split('.')) || 'pr'
      const url = data.code.filePath
      const fileInfo = {
        id: data.code.modelFileId,
        url,
        fileType,
      }
      const apiConfig = {
        path: `${Wiz.GetApiClientInstance('file-management')?.basePath}/api/file-management/files/${
          data.code.modelFileId
        }/download`,
        method: 'GET',
        headers: {
          Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
        },
      }
      const res = await downloadFile(
        this.player,
        fileInfo,
        apiConfig,
        this.progressMsg,
        this.downloadMsg
      )
      if (res.type === 0 && res.success) {
        // 有模型就加载模型
        this.sceneFileCount += 1
      } else {
        this.showLoadProgress = true
        this.loadType = '下载中...'
      }
    },
    // 监听下载模型是否成功
    downloadMsg(file, err) {
      this.loadPercentage = 0
      this.showLoadProgress = false
      if (err) {
        this.$message.warning(`下载文件失败，${file}, ${err}`)
      }
      this.sceneFileCount += 1
    },
    // 监听下载模型是否成功
    downloadMaterialMsg(data) {
      const that = this
      const fun = async (file, err) => {
        that.showLoadProgress = false
        that.loadPercentage = 0
        if (err) {
          that.$message.warning(`下载贴图文件失败，${file}, ${err}`)
        }
        setTimeout(() => {
          that.checkModelFile(data)
        }, 1500)
      }
      return fun
    },
    // 监听下载进度
    progressMsg(file, bytesReceived, bytesTotal) {
      if (bytesTotal) {
        this.loadPercentage = (bytesReceived / bytesTotal) * 100
      }
    },
    // 加载模型
    async loadModels() {
      let modelFileList = []
      if (this.loadModelType === 'modelFileId') {
        modelFileList = !_.isEmpty(this.modelFileList) ? [this.modelFileList[0]] : []
      }
      const modelList = _.map(modelFileList, (item) => {
        console.log('item', item)
        return {
          targetUrl: `data://../apps/${this.modelSetting.folderName}/models/${item.md5}/${item.md5}.pr`,
          fileUrl: `${Wiz.GetApiClientInstance().basePath}/api/file-management/files/${
            item.fileId
          }/download`,
          md5: item.md5,
          tempPath: `data://../temps/models/${item.md5}/${item.md5}.pr`,
          options: {
            modelId: item.fileId,
            httpOptions: {
              methods: 'GET',
              header: { Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}` },
            },
          },
        }
      })
      // this.checkModel(modelFileList) // 检查模型是否存在
      this.player.loadModelPtr = new this.currentCloudRender.Model(modelList, this.player)
    },
    // 模型点选
    watchMsg(data) {
      if (data) {
        this.$emit('updateModelNode', data)
        localStorage.setItem('currentModelNodeCode', data.code)
        // 获取选中模型节点的name
        this.modelTreeProp.currentNodeName = data ? data.name : ''
      }
    },
    async selectWatch(node, status) {
      if (this.lastSelectNode === node) return
      this.lastSelectNode = node
      let res = {}
      if (status && node) {
        res = await this.player.Native.Node.getProperty(node, ['code', 'name'])
      }
      this.$emit('updateModelNode', res || {})
      localStorage.setItem('currentModelNodeCode', res?.code ? res.code : '')
      this.modelTreeProp.currentNodeName = res?.name ? res.name : ''
    },
    handleScale() {
      if (this.$refs.modelEngine) {
        if (document.querySelector('.cockpit')) {
          this.$refs.modelEngine.style.transform = this.modelEngineTransform
        } else {
          this.$refs.modelEngine.style.transform = 'scale(1, 1)'
        }
      }
    },
    // 加载Gis地球效果
    async loadGisEarth(player, loadMapSrc, loadModelSrc, llh) {
      const isEnableEarthAnimation =
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.enableEarthAnimation || false
      const time =
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.animationTime || 9000
      if (isEnableEarthAnimation) {
        await player.Native.Model.loadModel('sample', loadModelSrc)
        // 9秒后执行
        const timer = setTimeout(async () => {
          await player.Native.GisPlatform.unloadMap()
          const info = await player.Native.Model.getInfo('sample')
          player.Native.Camera.moveToAabbWithFace([info.aabb.min, info.aabb.max], 1, 3)
          this.$emit('animationEnd', { type: 'custom', info: 'earth animation' })
          clearTimeout(timer)
        }, time)
      }
    },
    // 是否启用了gis地球动画
    isEnableGisEarthAnimation() {
      const isEnableEarthAnimation =
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config')
          ?.enableEarthAnimation || false
      if (!isEnableEarthAnimation) {
        this.$emit('animationEnd', { type: 'custom', info: 'earth animation' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.engineVideo {
  height: calc(100% + 15px);
}

.engineImg {
  height: calc(100% + 15px);
}

.error-color-bg {
  background: rgb(4 61 105 / 0.6);
}

.error-image-bg {
  background-image: url('../../assets/images/xinjiang_bg.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.model-view {
  // width: 100vw !important;
  height: 100vh !important;
  transform: scale(1, 1);
  transform-origin: 0 0;

  .el-loading-mask {
    background-color: rgb(87 118 129) !important;
  }

  &.no-loading-icon {
    ::v-deep .el-loading-spinner {
      display: none;
    }
  }
}
</style>
